import React, { useState } from 'react';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SettingsView = () => {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [loading, setLoading] = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.current_password || !form.new_password || !form.confirm_password) {
      toast.error('All fields are required'); return;
    }
    if (form.new_password.length < 8) {
      toast.error('New password must be at least 8 characters'); return;
    }
    if (form.new_password !== form.confirm_password) {
      toast.error('New passwords do not match'); return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.put(`${API}/admin/change-password`, {
        current_password: form.current_password,
        new_password: form.new_password
      }, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.success) {
        toast.success('Password changed successfully');
        setForm({ current_password: '', new_password: '', confirm_password: '' });
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to change password');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ maxWidth: '480px' }}>
      <h2 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Lock size={20} /> Change Password
      </h2>
      <form onSubmit={handleSubmit} data-testid="change-password-form">
        <div className="form-group" style={{ marginBottom: '16px' }}>
          <label className="form-label">Current Password</label>
          <div style={{ position: 'relative' }}>
            <input
              type={showCurrent ? 'text' : 'password'}
              className="form-input"
              value={form.current_password}
              onChange={(e) => setForm({ ...form, current_password: e.target.value })}
              data-testid="current-password"
            />
            <button type="button" onClick={() => setShowCurrent(!showCurrent)}
              style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#6B7280' }}>
              {showCurrent ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </div>
        <div className="form-group" style={{ marginBottom: '16px' }}>
          <label className="form-label">New Password</label>
          <div style={{ position: 'relative' }}>
            <input
              type={showNew ? 'text' : 'password'}
              className="form-input"
              value={form.new_password}
              onChange={(e) => setForm({ ...form, new_password: e.target.value })}
              placeholder="Minimum 8 characters"
              data-testid="new-password"
            />
            <button type="button" onClick={() => setShowNew(!showNew)}
              style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#6B7280' }}>
              {showNew ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </div>
        <div className="form-group" style={{ marginBottom: '24px' }}>
          <label className="form-label">Confirm New Password</label>
          <input
            type="password"
            className="form-input"
            value={form.confirm_password}
            onChange={(e) => setForm({ ...form, confirm_password: e.target.value })}
            data-testid="confirm-password"
          />
        </div>
        <button type="submit" className="btn-primary" disabled={loading} data-testid="change-password-btn"
          style={{ width: '100%' }}>
          {loading ? 'Changing...' : 'Change Password'}
        </button>
      </form>
    </div>
  );
};

export default SettingsView;
